import * as React from "react";
import { connect } from "react-redux";
import { Redirect, withRouter, NavLink } from "react-router-dom";

import { FormattedMessage, InjectedIntlProps, injectIntl } from "react-intl";

import { History } from "history";

import * as CSS from "csstype";

/* eslint-disable import/no-webpack-loader-syntax */
import FailedIcon from "-!svg-react-loader!../../images/icn-failure.svg";
import SpinnerIcon from "../../images/spinner.png"
/* eslint-enable import/no-webpack-loader-syntax */

import "./styles.css";

import {
  Alert,
  Button,
  ControlLabel,
  Form,
  FormControl,
  FormGroup
} from "react-bootstrap";

import { userActions } from "../../actions/user.actions";
import { IAuthenticationState } from "../../contracts/IAuthenticationState";
import { IRootState } from "../../reducers";

import { ILocalizedError } from "src/i18n/error-localization";
import { loginMessages } from "./messages";

import Footer from "./footer";

import { ProductTitle } from "./product-title";

interface IProps extends InjectedIntlProps {
  password: string;
  username: string;
  authState: IAuthenticationState;
  onLoginRequest: (username: string, password: string, history: any) => void;
  onLoginFailed: (error: ILocalizedError) => void;
  onLogout: (history: History) => void;
  history: any;
}

interface IState {
  loading: boolean;
  password: string;
  username: string;
}

class LoginPage extends React.Component<IProps, IState> {
  private userNameInput: HTMLInputElement;
  private userPasswordInput: HTMLInputElement;

  constructor(props: IProps) {
    super(props);

    this.state = {
      loading: false,
      password: "",
      username: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.refUsernameInput = this.refUsernameInput.bind(this);
    this.refPasswordInput = this.refPasswordInput.bind(this);
  }

  public componentDidMount() {
    document.body.classList.remove("main-body-theme");
    document.body.classList.add("login-body-theme");
  }

  public handleChange(e: any) {
    const { name, value } = e.target;
    this.setState(prevState => ({
      ...this.state,
      [name]: value
    }));
  }

  public refUsernameInput(ref: HTMLInputElement): void {
    this.userNameInput = ref;
  }

  public refPasswordInput(ref: HTMLInputElement): void {
    this.userPasswordInput = ref;
  }

  public handleSubmit(e: any) {
    e.preventDefault();

    const { username, password } = this.state;

    if (!this.state.username) {
      this.props.onLoginFailed(loginMessages.usernameNotSet);
      this.setState({ loading: false });
      this.userNameInput.focus();
    } else if (!this.state.password) {
      this.props.onLoginFailed(loginMessages.passwordNotSet);
      this.setState({ loading: false });
      this.userPasswordInput.focus();
    } else {
      this.setState({ loading: true });
      this.props.onLoginRequest(username, password, this.props.history);
    }
  }

  public render() {
    const { isLoggedIn, error } = this.props.authState;
    const { username, password, loading } = this.state;
    const formatMessage = this.props.intl.formatMessage;

    if (isLoggedIn) {
      return <Redirect to="home" />;
    }

    const activeStyle: CSS.Properties = {
      // Add a CSS Custom Property
      ["active" as any]: "active"
    };

    return (
      <React.Fragment>
        <div className="container-fluid">
          <ProductTitle />
          <div>
            <Form inline={true} onSubmit={this.handleSubmit}>
              <FormGroup
                controlId="formUsername"
                validationState={error && !username ? "error" : null}
              >
                <ControlLabel>
                  <FormattedMessage
                    id="login-page.username.label"
                    defaultMessage="username"
                  />
                </ControlLabel>
                <FormControl
                  name="username"
                  inputRef={this.refUsernameInput}
                  type="text"
                  placeholder={formatMessage(loginMessages.usernamePlaceholder)}
                  value={username}
                  disabled={loading && !error}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup
                className="password-input"
                controlId="formPassword"
                validationState={error && !password ? "error" : null}
              >
                <ControlLabel>
                  <FormattedMessage
                    id="login-page.password.label"
                    defaultMessage="password"
                  />
                </ControlLabel>
                <FormControl
                  inputRef={this.refPasswordInput}
                  name="password"
                  type="password"
                  placeholder={formatMessage(loginMessages.passwordPlaceholder)}
                  value={password}
                  disabled={loading && !error}
                  onChange={this.handleChange}
                  style={activeStyle}
                />
                <NavLink to="/password/reset" className="link-forgot-password">
                  <FormattedMessage
                  id="login-page.login.forgot-link"
                  defaultMessage="forgot the password?"
                />
                </NavLink>
              </FormGroup>
              <Button
                type="submit"
                className="login-button"
                disabled={loading && !error}
              >
                <FormattedMessage
                  id="login-page.login.button"
                  defaultMessage="Login"
                />
              </Button>
            </Form>
            {error && (
              <Alert bsStyle="warning" className="validation_message">
                <FailedIcon className="failed-icon" />{" "}
                <FormattedMessage
                  id={error.id || ""}
                  defaultMessage={error.defaultMessage}
                />
              </Alert>
            )}
            {loading && !error && (
              <img alt="" src={SpinnerIcon} className="spinner" />
            )}
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: IRootState, ownProps: any) => ({
  authState: state.authState
});

const mapDispatchToProps = (dispatch: any) => ({
  onLoginRequest: (username: string, password: string, history: any) =>
    dispatch(userActions.loginRequestAction(username, password, history)),

  onLoginFailed: (error: ILocalizedError) =>
    dispatch(userActions.loginFailedAction(error)),

  onLogout: (history: History) => dispatch(userActions.logoutAction(history))
});

const connectedLoginPage = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(LoginPage))
);

export { connectedLoginPage as LoginPage };



// WEBPACK FOOTER //
// ./src/scenes/login-page/index.tsx